/**
 * Structural rather than `SellerInfo`, so the listing page's panels can pass
 * whatever shape they hold without this helper reaching into the query types.
 */
type NameableSeller = {
  storefront?: { name?: string | null } | null
  account?: { displayName?: string | null } | null
}

/**
 * The one name a Seller Collects seller is introduced under.
 *
 * The storefront name wins because it is what the buyer searched and browsed
 * under; a legal name at the moment of committing money can read as an
 * unrelated company. `sellerCollectsConfig.sellerLegalName` belongs where
 * payment instructions are actually rendered — an invoice or a wire form the
 * buyer acts on — not in the panels and modals that describe the arrangement.
 *
 * Empty where the seller cannot be named at all; callers fall back to generic
 * copy rather than printing nothing — some want `undefined` instead, so they
 * write `|| undefined` rather than this returning two different empties.
 *
 * Covers the listing page's payment panel and the bid and Buy Now modals,
 * which is the span FP-3483 is about. The order-page surfaces
 * (`SellerCollectsContacts`, `SellerCollectsFirstWinModal`,
 * `sellerCollectsOrderCard`) and `useListingTagsModel` still spell the chain
 * out by hand and should move here too, once the merge requests currently
 * rewriting them have landed.
 */
export const getSellerCollectsSellerName = (
  seller: NameableSeller | undefined
): string => seller?.storefront?.name ?? seller?.account?.displayName ?? ''
